module.exports = __webpack_public_path__ + "img/icon_03.387a1ce1.png";